import { useEffect, useState } from 'react'
import api from '../../services/api'

// A product's usage figures, and the hook that reads them. Kept out of ProductMetrics.jsx so that
// file exports components only (fast refresh needs that).

export const TILES = [
  { key: 'site_visits', label: 'Site visits' },
  { key: 'questions_asked', label: 'Questions asked' },
  { key: 'time_spent', label: 'Time spent' },
  { key: 'last_visit', label: 'Last visit' },
]

export function show(key, value) {
  if (value === null || value === undefined || value === '') return '—'
  if (key === 'last_visit') {
    const d = new Date(value)
    if (isNaN(d)) return String(value)
    const today = new Date()
    const sameDay = d.toDateString() === today.toDateString()
    return sameDay ? 'Today' : d.toLocaleDateString()
  }
  return typeof value === 'number' ? value.toLocaleString() : String(value)
}

/** Reads a product's usage figures, once per product; `load` reads them again. Owned by the page,
 *  so the figures can be drawn either on their own card or among the opening screen's cards. */
export function useProductMetrics(productKey) {
  const [state, setState] = useState(null)
  const [busy, setBusy] = useState(false)

  const load = async () => {
    setBusy(true)
    try {
      const { data } = await api.get(`/platform/products/${productKey}/metrics`)
      setState(data)
    } catch (e) {
      setState({ available: false, reason: e.response?.data?.detail || 'Could not read the usage figures.' })
    } finally { setBusy(false) }
  }
  useEffect(() => { setState(null); load() }, [productKey])

  return { state, busy, load }
}

/** The four figures as screen cards ({label, value}), for drawing among a screen's own. */
export const usageStats = (data) => TILES.map(t => ({ label: t.label, value: show(t.key, data?.[t.key]) }))
